import { Content, H3, Row } from 'Constants/styles';
import React, { ReactElement } from 'react';

import { useCreateMarketplaceContext } from '../context';
import { MarketplaceBasicInfoTable, Media, RowP } from './styles';

const MarketplaceBasicInfo = (): ReactElement => {
  const { marketplaceId, marketplace } = useCreateMarketplaceContext();

  return (
    <MarketplaceBasicInfoTable>
      <Content>
        <Row>
          <div className="col-sm-8">
            <Media>
              {marketplace && (
                <>
                  <H3 className="pt-2 pb-0">{marketplace.businessName}</H3>
                </>
              )}
            </Media>
          </div>
        </Row>

        <Row>
          <RowP>Marketplace Id: #{marketplaceId}</RowP>
        </Row>

        {marketplace && (
          <div className="items">
            <ul className="item-list">
              <li className="item item-list-header">
                <div className="item-row">
                  <div className={`item-col`}>
                    <div className={`item-label`}>Enterprise ID</div>
                    <div className={`item-value`}>{marketplace.enterpriseId || '-'}</div>
                  </div>
                  <div className={`item-col`}>
                    <div className={`item-label`}>Readable identifier</div>
                    <div className={`item-value`}>{marketplace.slug}</div>
                  </div>
                  <div className={`item-col`}>
                    <div className={`item-label`}>Website</div>
                    <div className={`item-value`}>{marketplace.website}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        )}
      </Content>
    </MarketplaceBasicInfoTable>
  );
};

export default MarketplaceBasicInfo;
